import CheckIconAlt from '@src/svgs/CheckIconAlt';
import styled from 'styled-components';

/**
 * Selection indicator for pick-one card grids — template pickers, image
 * pickers, composition pickers.
 *
 * Per docs/design-system.md → "Selectable Items", selection on a card is
 * carried by this gold check, not by an action-looking hover button (which
 * reads as "this applied it") and not by an accent border alone.
 *
 * Sits top-LEFT so it can never collide with a card's top-right affordances
 * (an AI marker, a duration badge). The host card must be `position: relative`.
 * Decorative: the accessible state belongs on the card itself
 * (`aria-pressed` / `aria-selected`).
 */
export default function SelectedCheckBadge({
  className,
  'data-testid': dataTestId,
}: {
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <Badge className={className} data-testid={dataTestId} aria-hidden="true">
      <CheckIconAlt />
    </Badge>
  );
}

const Badge = styled.span`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--accent);
`;
